import { Box, Button, Typography, useTheme } from "@material-ui/core";
import { graphql } from "gatsby";
import React from "react";

export default function PartnersRequestSampleKit({
  title,
  image,
  externalLink
}: Queries.PartnersRequestSampleKitFragmentFragment) {
  const theme = useTheme();
  return (
    <Box
      display="flex"
      flexDirection={{ xs: "column-reverse", md: "row" }}
      bgcolor="primary.main"
      borderRadius="8px"
      overflow="hidden"
    >
      <Box paddingX={{ xs: 2, md: 8 }} paddingY={{ xs: 4, md: 8 }} flex={2}>
        <Box mb={{ xs: 3 }}>
          <Typography variant="h4" style={{ maxWidth: "365px", lineHeight: 1 }}>
            {title}
          </Typography>
        </Box>
        <Box pb={1} mb={1} borderBottom={`1px solid rgba(0, 0, 0, .2)`}>
          <Typography variant="body1">
            Try and test Airgraft hardware with your extracts*.
            <br />
            Each kit contains:
          </Typography>
        </Box>
        <Box pb={1} mb={1} borderBottom={`1px solid  rgba(0, 0, 0, .2)`}>
          <Typography variant="body1">
            <div>8 Airgraft pods with pre-set heating algorithms:</div>
            <div>
              <strong>2 x Flavor / 3 x Balanced / 3 x Vapor</strong>
            </div>
          </Typography>
        </Box>
        <Box pb={1} mb={4} borderBottom={`1px solid  rgba(0, 0, 0, .2)`}>
          <Typography variant="body1">
            2 Airgraft Batteries, Filling & heat settings manual
          </Typography>
        </Box>

        <Button
          variant="contained"
          className="white"
          fullWidth
          component="a"
          target="_blank"
          href={externalLink}
          data-analytics="partners.request-sample-kit"
        >
          Request sample kit
        </Button>

        <Box mt={2}>
          <Typography variant="body2">
            *Oil brands & processors only.
          </Typography>
        </Box>
      </Box>

      <Box
        flex={3}
        bgcolor="secondary.main"
        style={{
          backgroundImage: `url(${image.url}&fit=fill&max-w=1000)`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top"
        }}
        minHeight={{ xs: "220px", sm: "300px", lg: "none" }}
      ></Box>
    </Box>
  );
}

export const PartnersRequestSampleKitFragment = graphql`
  fragment PartnersRequestSampleKitFragment on DatoCmsCModulePartnersRequestSampleKit {
    title
    image: background {
      url
    }
    externalLink: link
    container
    innerContainer
    containerDisableGutters
    containerBackgroundColor
    model {
      apiKey
    }
  }
`;
